import { FilterLayoutProps } from '../types';

import FilterAndSortButton, {
  FilterAndSortButtonProps,
} from './FilterAndSortButton';

interface FilterMobileProps extends FilterLayoutProps {
  filterAndSortButtonOptions: FilterAndSortButtonProps;
}

const FilterMobile = ({
  before,
  search,
  after,
  children,
  filterAndSortButtonOptions,
}: FilterMobileProps) => (
  <div
    className="flex flex-col gap-4 pb-4 md:hidden"
    data-testid="filter-mobile"
  >
    {before && <div className="flex flex-col gap-[5px]">{before}</div>}
    <div className="flex gap-4">
      {search}
      {(children ?? filterAndSortButtonOptions.sortOnly) && (
        <FilterAndSortButton
          {...filterAndSortButtonOptions}
          className="items-stretch"
        >
          <div
            data-testid="filter-mobile-main"
            className="flex w-full flex-col items-stretch gap-4"
          >
            {children}
          </div>
        </FilterAndSortButton>
      )}
    </div>
    {after && <div data-testid="filter-mobile-after">{after}</div>}
  </div>
);

export default FilterMobile;
